import { BaseTooltipModel } from '../common';

export interface TreatmentTypeFile {
    fileKind: number;
    treatmentTypeId: number;
    name: string;
    required: boolean;
    accept: string;
    title: string;
    type: number;
    grouping: TreatmentTypeFileGroup;
    multiple: boolean;
    isPrintable: boolean;
    maxMegabytes: number;
    groupBase: number;
    isActive: boolean;
    order: number;
    imagePath: string;
    minBytes: number;
}

export interface TreatmentTypeFileGroup {
    id: number;
    name: string;
    description: string;
    subGroupBase: number;
    order: number;
    onlyView: boolean;
    tooltip: BaseTooltipModel;
    required: boolean;
}

export const DefaultTreatmentTypeFileGroup: TreatmentTypeFileGroup = {
    id: 0,
    name: '',
    description: '',
    order: 0,
    onlyView: false,
    subGroupBase: 0,
    tooltip: {},
    required: true
};
